var Case = { exports: {} };
export { Case as C };
